import * as React from 'react';
import { UIText3 } from '@cian/ui-kit';
import cx from 'clsx';

import { ImageSourcesButton } from './ImageSourcesButton';

import * as styles from './styles.css';
import { CollapsedBlock } from '../CollapsedBlock';

export const ImageSources = ({ children, defaultOpened }: React.PropsWithChildren<{ defaultOpened?: boolean }>) => {
  const [opened, setOpened] = React.useState(defaultOpened || false);

  return (
    <div className={styles['container']}>
      <CollapsedBlock
        collapsedHeight={20}
        className={cx(styles['block'], opened && styles['block_opened'])}
        onChangeOpen={setOpened}
        Button={ImageSourcesButton}
      >
        <UIText3 color={'surface-neutral-pressed'}>{children}</UIText3>
      </CollapsedBlock>
    </div>
  );
};
